export * from './goal.class';
